import script from "./bannerHero.vue?vue&type=script&setup=true&lang=js"
export * from "./bannerHero.vue?vue&type=script&setup=true&lang=js"

import "./bannerHero.vue?vue&type=style&index=0&id=33091db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33091db4"]])

export default __exports__